module.exports = __webpack_public_path__ + "static/media/jerryIcon.e13aff24.png";